import { defineComponent as _defineComponent } from 'vue';
import { computed, watch, toRefs, ref } from 'vue';
import { useMapStore } from '@blade-sxp/screen-new/store/map';
import mapStore3d from '@blade-sxp/map/src/store';
import MapCommon from '@blade-sxp/map/components/index.vue';
import colors from '@/styles/color.scss';
import { Loading } from 'element-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        let loading2D = false;
        const store = useMapStore();
        const mapData = computed(() => store.mapData);
        const stMap = ref();
        const { mapUrl = '', mapId = '', backgroundColor = colors.black, mapType, mainAngle, toolTipsList = [], roiList = [], deviceList = [], heatMapList = [], lineList = [], imageList = [], autoRotate, personList = [], carParkingList = [], weather = 'sunny', sunAngle = 0, } = toRefs(mapData.value);
        watch(() => mapUrl.value, (newUrl, oldUrl) => {
            if (mapType.value === '2D' && newUrl !== oldUrl) {
                loading2D = Loading.service({
                    customClass: 'icon-map-loading',
                    lock: true,
                    spinner: 'el-icon-loading',
                    background: colors.taskShadows,
                });
            }
        });
        const mapUrlLoad = () => {
            loading2D.close();
        };
        const onload = () => {
            store.stMap = stMap;
        };
        /** 3D loading start **/
        const progress = ref(0);
        const loading = ref(false);
        const onStart = () => {
            progress.value = 0;
            loading.value = true;
        };
        const onEnd = () => {
            mapStore3d.onSmoothChange((isSmooth) => {
                if (isSmooth)
                    loading.value = false;
            });
        };
        const onError = (err) => {
            loading.value = false;
            console.log(err);
        };
        const onProgress = (schedule) => {
            progress.value = Number((parseInt(String((schedule.loaded / schedule.total) * 1000)) / 10).toFixed(2));
        };
        /** 3D loading end **/
        const handleMapClick = () => {
            store.updateMapClick();
        };
        return { __sfc: true, loading2D, store, mapData, stMap, mapUrl, mapId, backgroundColor, mapType, mainAngle, toolTipsList, roiList, deviceList, heatMapList, lineList, imageList, autoRotate, personList, carParkingList, weather, sunAngle, mapUrlLoad, onload, progress, loading, onStart, onEnd, onError, onProgress, handleMapClick, MapCommon };
    }
});
